
import { map,  tap } from 'rxjs/operators'
import { StoreThunkAction, StoreThunkDispatch } from 'store/state'
import { Observable } from 'rxjs'




import { StatusIdea, Paginated, STATUS_TYPE } from 'interfaces'
import { V1 } from './net'
import { statusIdeasAdapter } from '../util'
import { createAction } from '@reduxjs/toolkit'

export function getStatusIdeas(categoryIds: Array<string>, page = 0, seed?: string): StoreThunkAction<Observable<Paginated<StatusIdea[]>>> {
  return (dispatch, _getState) => {
    return dispatch(V1.getStatusIdeas(categoryIds, page, seed)).pipe(map(statusIdeasAdapter))
  }
}

function statusIdeaAdapter(s: any) {
  return { ...s, id: s.id.toString(), type: STATUS_TYPE }
}

export function searchStatusIdeas(
  query: string, page: number, tag?: string
): StoreThunkAction<Observable<{ data: StatusIdea[], totalCount: number }>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.searchStatusIdeas(query, page, tag)).pipe(map((response: any) => {
      const data = typeof response.statusIdeas.length === 'number' ? response.statusIdeas : response.statusIdeas.statusIdeas
      return { data: data.map(statusIdeaAdapter), totalCount: response.statusIdeas.count }
    }))
  }
}

export const addRecentStatusSearch = createAction<string>('content/statuses/addRecentStatusSearch')
export const setRecentStatusSearches = createAction<string[]>('content/statuses/setRecentStatusSearches')
export const setPastStatusesSearches = createAction<any[]>('content/statuses/setPastStatusesSearches')
export function getPastSearches() {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.getPastSearches())
    .pipe(tap((response) => {
      dispatch(setPastStatusesSearches(response.searches.map((s: any) => s.term)))
    })).pipe(
      map(response => response.searches))
}

export function deleteSavedSearch(text: string) {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.deleteSavedSearch(text)).pipe(map(() => text))
}

export function saveSearch(query: string): StoreThunkAction<Observable<string>> {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.saveSearch(query)).pipe(map(() => query))
}

export function getStatusesRange(from: number, to: number): StoreThunkAction<Observable<StatusIdea[]>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.getStatusesRange(from, to)).pipe(map(response => {
      return response.quotes.quotes.map(statusIdeaAdapter)
    }))
  }
}

export function getTotalStatusesCount() {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.searchStatusIdeas('', 0)).pipe(map((response: any) => response.statusIdeas.count))
}

export function createStatusIdea(status: string, tags?: string[]): StoreThunkAction<Observable<any>> {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.createStatusIdea(status, tags))
}

export function getTags(all?: boolean) {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.getTags()).pipe(map(response => {
    if (all) {
      return response.map((tag: any) => ({ ...tag, active: Boolean(tag.isVisible) }))
    }
    return response
      .filter((tag: any) => tag.isVisible)
      .map((tag: any) => ({ ...tag, active: Boolean(tag.isVisible) }))
  }))
}

export function updateTag(id: number, active: boolean) {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.updateTag(id, active)).pipe(map((response) => {
    if (response.error) {
      throw new Error(response.msg)
    }
    return {
      id, active
    }
  }))
}

export function updateStatus(id: string, status: string, author?: string, tags?: string[]): StoreThunkAction<Observable<any>> {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.updateStatus(id, status, author, tags))
}

export function deleteStatus(id: string): StoreThunkAction<Observable<any>> {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.deleteStatus(id))
}
